import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { FullRow, Row, Col } from "../../framework/Grid/";
import map from "lodash/map";
import isNil from "lodash/isNil";
import { splitNumber } from "../../../utils/utility";

class FrequencyVisitorList extends AcquireWebComponent {
  render() {
    const { title, data } = this.props;

    return (
      <div className="pb-20 bg-white" key={"key-" + title.replace(" ", "-")}>
        <FullRow className="no-padding-bottom mb-20">
          <div
            style={{
              fontWeight: "bold",
              fontSize: "24px",
              letterSpacing: "-0.015em",
            }}
          >
            {title}
          </div>
        </FullRow>
        <Row
          className="no-margin-bottom ml-20 mr-20"
          style={{ background: "#F5F5F5" }}
        >
          <Col xs="2" sm="2" md="2" lg="2" className="pl-10">
            <strong>Company <br />Name</strong>
          </Col>
          <Col xs="4" sm="4" md="4" lg="4">
            <strong>Industry</strong>
          </Col>
          <Col xs="2" sm="2" md="2" lg="2">
            <strong>Annual Revenue</strong>
          </Col>
          <Col xs="2" sm="2" md="2" lg="2">
            <strong>Number of Employees</strong>
          </Col>
          <Col xs="2" sm="2" md="2" lg="2" className="text-right">
            <strong>Age of Business</strong>
            <br />
            (in years)
          </Col>
        </Row>
        {map(data, function(obj, index) {
          return (
            <Row
              key={"frequency-visits-item-" + index}
              style={{ fontWeight: 300 }}
              className="no-margin-bottom ml-20 mr-20 pb-15 pt-15"
              style={{ borderBottom: "1px solid #f5f5f5" }}
            >
              <Col
                xs="2"
                sm="2"
                md="2"
                lg="2"
                className="pl-10"
                style={{ color: "#017FB5" }}
              >
                {obj.companyName.substring(0, 2) + "******"}
              </Col>
              <Col xs="4" sm="4" md="4" lg="4">
                <div
                  style={{ width: "100%" }}
                  className="ellipse-cell"
                  data-text={obj.industry}
                >
                  {obj.industry}
                </div>
              </Col>
              <Col xs="2" sm="2" md="2" lg="2">
                {isNil(obj.revenue) ? "-" : "$" + splitNumber(obj.revenue)()}
              </Col>
              <Col xs="2" sm="2" md="2" lg="2">
                {isNil(obj.employees) ? "-" : splitNumber(obj.employees)()}
              </Col>
              <Col
                xs="2"
                sm="2"
                md="2"
                lg="2"
                className="text-right"
                style={{ paddingRight: "80px" }}
              >
                {obj.age ? obj.age : "-"}
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }
}

FrequencyVisitorList.propTypes = {
  title: React.PropTypes.string.isRequired,
  data: React.PropTypes.array,
};
export default FrequencyVisitorList;



// WEBPACK FOOTER //
// ./src/components/Insights/page/FrequencyVisitorList.jsx